import { Award, Linkedin } from "lucide-react";
import { cdnPath } from "@/utility/api";

// Instructors Component
const SDEInstructor = () => {
  const instructors = [
    {
      name: "Sanya Dureja",
      linkedinUrl: "https://www.linkedin.com/in/sanya-dureja-13960122a/",
      description:
        "Incoming SDE-1 @PayPal | Ex - SWE Intern @PayPal | AI Intern @NYX",
      image:`${cdnPath}/SanyaDureja.jpg`,
    },
    {
      name: "Charchit Kurra",
      linkedinUrl: "https://www.linkedin.com/in/charchit-kurra-3698b821a/",
      description: "BCG || Grant Thornton || Tata 1mg || Blinkit || Bain & Co.",
      image: `${cdnPath}/charchit_author.jpg`,
    },
  ];

  return (
    <div className="bg-black py-24 px-4">
      <div className="max-w-5xl mx-auto relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 rounded-3xl blur-3xl -z-10"></div>

        <div className="flex items-center justify-center mb-6">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 backdrop-blur-sm">
            <Award className="w-4 h-4 text-blue-400" />
            <span className="text-sm font-semibold text-blue-400 tracking-wide uppercase">
              Expert Guidance
            </span>
          </div>
        </div>

        <h2 className="text-center text-3xl sm:text-5xl font-bold mb-4">
          <span className="bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
            Meet Your Instructors
          </span>
        </h2>

        <p className="text-gray-400 text-center max-w-2xl mx-auto mb-16">
          Learn from industry professionals who have walked the path and know
          exactly what it takes to succeed in today's competitive landscape.
        </p>

        {/* Changed from flex justify-center to flex flex-col md:flex-row */}
        <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-4">
          {instructors.map((instructor, index) => (
            <div
              key={index}
              className="group relative w-full max-w-md mx-auto md:mx-0"
            >
              {/* Mobile Card Wrapper - Only visible on mobile */}
              <div className="md:hidden bg-blue-900/10 backdrop-blur-sm border border-blue-500/20 rounded-2xl p-6">
                {/* Instructor Container */}
                <div className="flex flex-col items-center text-center">
                  {/* Decorative elements */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl -z-10"></div>
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-60 h-60 bg-indigo-500/10 rounded-full blur-3xl -z-10"></div>

                  {/* Image */}
                  <div className="relative mb-8">
                    <div className="w-40 h-40 rounded-full overflow-hidden border-2 border-blue-400/50 p-1">
                      <img
                        src={instructor.image || "/placeholder.svg"}
                        alt={instructor.name}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                  </div>

                  {/* Name */}
                  <h3 className="text-2xl font-bold mb-3 text-white">
                    {instructor.name}
                  </h3>

                  {/* Role/Title */}
                  <div className="mb-4">
                    <span className="px-4 py-1.5 bg-blue-500/10 text-blue-400 rounded-full text-sm font-medium border border-blue-500/20">
                      Lead Instructor
                    </span>
                  </div>

                  {/* LinkedIn Icon */}
                  <a
                    href={instructor.linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-500/10 mb-6 hover:bg-blue-500/30 transition-colors duration-300"
                  >
                    <Linkedin className="w-6 h-6 text-blue-400" />
                  </a>

                  {/* Description */}
                  <p className="text-gray-300 text-lg">
                    {instructor.description}
                  </p>
                </div>
              </div>

              {/* Desktop Layout - Only visible on desktop */}
              <div className="hidden md:flex md:flex-col items-center text-center">
                {/* Decorative elements */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl -z-10"></div>
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-60 h-60 bg-indigo-500/10 rounded-full blur-3xl -z-10"></div>

                {/* Image with hover effect on desktop */}
                <div className="relative mb-8 transition-all duration-300 md:group-hover:transform md:group-hover:scale-105">
                  <div className="w-40 sm:w-48 h-40 sm:h-48 rounded-full overflow-hidden border-2 border-blue-400/50 p-1">
                    <img
                      src={instructor.image || "/placeholder.svg"}
                      alt={instructor.name}
                      className="w-full h-full object-cover rounded-full"
                    />
                  </div>

                  {/* Glow effect on hover (desktop only) */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full blur-md opacity-0 md:group-hover:opacity-30 transition-opacity duration-300 -z-10"></div>
                </div>

                {/* Name */}
                <h3 className="text-2xl sm:text-3xl font-bold mb-3 text-white md:group-hover:text-blue-300 transition-colors duration-300">
                  {instructor.name}
                </h3>

                {/* Role/Title */}
                <div className="mb-4">
                  <span className="px-4 py-1.5 bg-blue-500/10 text-blue-400 rounded-full text-sm font-medium border border-blue-500/20">
                    Lead Instructor
                  </span>
                </div>

                {/* LinkedIn Icon */}
                <a
                  href={instructor.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-500/10 mb-6 hover:bg-blue-500/30 transition-colors duration-300"
                >
                  <Linkedin className="w-6 h-6 text-blue-400" />
                </a>

                {/* Description - Hidden on desktop until hover */}
                <div className="overflow-hidden transition-all duration-500 ease-in-out max-h-0 opacity-0 mt-0 md:group-hover:max-h-24 md:group-hover:opacity-100 md:group-hover:mt-2">
                  <p className="text-gray-300 transition-colors text-lg md:px-6 md:py-4 md:bg-blue-900/20 md:backdrop-blur-sm md:rounded-xl md:border md:border-blue-500/20 md:text-gray-400 md:group-hover:text-blue-100">
                    {instructor.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SDEInstructor;
